import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth, isPlanActive } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, requirePlan = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950 text-white grid place-items-center">
        <div className="h-10 w-10 rounded-full border-2 border-emerald-500 border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requirePlan && !isPlanActive(user)) return <Navigate to="/acesso-bloqueado" replace />;
  return children;
}
